<script setup lang="ts">
  import { computed } from 'vue'
  import tradutor from '../../tradutors/afiliados'
  import { localeStore } from '../../stores/locale'
  const store = localeStore()
  const translate = computed(() => {
    if (store.locale === 'pt-br') {
      return tradutor.portugues
    } else {
      return tradutor.ingles
    }
  })
</script>
<template>
  <div class="box-central">
    <div class="bbox-content bbox-c-clean">
      <div id="div-affiliate-home">
        <div>
          <div class="header">
            <img
              :src="translate.imgHome"
              alt="partner-fluxo"
            />
          </div>

          <br />
          <div class="div-affiliate-home" v-html="translate.html"></div>

          <div style="text-align: center">
            <br />

            <img
              :src="translate.imgFooter"
              alt="bella"
              width="474"
              height="115"
              usemap="#MapAf1"
            />

            <map name="MapAf1" id="MapAf1">
              <area
                shape="rect"
                coords="34,10,199,52"
                :href="`/${store.locale}/programa-afiliados/subscribe`"
              />
              <area
                shape="rect"
                coords="252,10,426,54"
                :href="`/${store.locale}/programa-afiliados/faq`"
              />
              <area
                shape="rect"
                coords="174,81,266,109"
                :href="`/${store.locale}/programa-afiliados/subscribe`"
              />
            </map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="css">
  .header img {
    width: 100%;
  }
  h3 {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-block: 12px;
  }
  a {
    font-weight: 700 !important;
  }
</style>
